import { WaterBalanceTypesEnum } from '@common-modules/dependencies/water-balance/water-balance-types';

export class WaterBalanceTypeOption {
  constructor(public label: string, public value: WaterBalanceTypesEnum) {}
}
